import { useDispatch } from 'react-redux';
import { AppDispatcher } from '../stores/types';

export const useAppDispatch = () => useDispatch<AppDispatcher>();